export default __webpack_public_path__ + "static/media/Twigs of the Ocean.1ad24491.jpg";